import React, { useCallback, useRef, useState } from "react"
import styled from "styled-components"
import { Col, Form, FormControl, Row } from "react-bootstrap"
import { ReactComponent as CloseIcon } from "../../images/close.svg"

const ChipInput = styled.div`
    box-shadow: 0 0 0 0.2rem transparent;
    border: 1px solid transparent;
    transition: border 0.15s linear, box-shadow 0.15s linear;
    &.highlighted {
        border-color: #80bdff;
    }
`

const Chip = styled.div`
    padding: 2px 4px 3px 8px;
    border-radius: 16px;
    border: 1px solid #d9d9d9;
    background-color: #d9d9d9;

    transition: box-shadow 0.15s linear, background-color 0.15s linear, border 0.15s linear;

    &:hover,
    &:focus,
    &:active {
        border-color: #202428;
        background-color: #dedede;
    }
`

interface ReactChipInputProps {
    id: string
    placeholder?: string
    chips: readonly string[]
    chipsLimit: number
    onChange?: (chips: Array<string>) => void
}

const ChipsControl: React.FC<ReactChipInputProps> = ({ id, placeholder, chips = [], chipsLimit, onChange }) => {
    const formControlRef = useRef<HTMLInputElement>(null)
    const [focused, setFocused] = useState(false)
    const onAddChipHandler = useCallback(
        (event: any) => {
            event.preventDefault()
            if (formControlRef && formControlRef.current) {
                console.log(formControlRef.current.value)
                const chipst = chips.slice()
                chipst.push(formControlRef.current.value)
                onChange?.(chipst)
                formControlRef.current.value = ""
            }
        },
        [chips, onChange]
    )

    const onRemoveChipHandler = useCallback(
        (index: number) => {
            const chipst = chips.slice()
            chipst.splice(index, 1)
            onChange?.(chipst)
        },
        [chips, onChange]
    )

    return (
        <ChipInput id={id} className={focused ? "highlighted" : ""}>
            <Row className="align-items-center" noGutters>
                {chips.map((chip, index) => (
                    <Col xs="auto" className="p-2" key={index}>
                        <Chip>
                            {chip}
                            <CloseIcon style={{ height: "19px" }} className="ml-2" onClick={() => onRemoveChipHandler(index)} />
                        </Chip>
                    </Col>
                ))}
                {chips.length < chipsLimit && (
                    <Col xs>
                        <Form className="chips-form-control" onSubmit={onAddChipHandler} noValidate>
                            <FormControl
                                ref={formControlRef}
                                name="chipInput"
                                placeholder={placeholder}
                                aria-label="Chip Input"
                                className="m-0 border-0 mb-0"
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </Form>
                    </Col>
                )}
            </Row>
        </ChipInput>
    )
}

export default ChipsControl
